// TLDSelector Layout Component

import React from 'react';
import { Tag, Box, Text, Tooltip } from '@wix/design-system';
import { CoreDomainSearchDataHooks } from '../../module/module';
import tldSelectorStyles from './TldSelector.scss';
import classnames from 'clsx';
import { GiftSmall } from '@wix/wix-ui-icons-common/lazy';
import { TLDTooltipContent } from './TLDTooltipContent';
import { useIsMobile } from '../../hooks/useIsMobile';
export const TLDSelector = _ref => {
  let _ref$selectedTlds = _ref.selectedTlds,
    selectedTlds = _ref$selectedTlds === void 0 ? [] : _ref$selectedTlds,
    availableTlds = _ref.availableTlds,
    _ref$maxSelections = _ref.maxSelections,
    maxSelections = _ref$maxSelections === void 0 ? 6 : _ref$maxSelections,
    stretch = _ref.stretch,
    onChange = _ref.onChange;
  const isMobile = useIsMobile();
  const handleTldToggle = tld => {
    const isSelected = selectedTlds.includes(tld);
    let newTlds;
    if (isSelected) {
      // Remove TLD
      newTlds = selectedTlds.filter(t => t !== tld);
    } else {
      // Add TLD if under max limit
      if (selectedTlds.length < maxSelections) {
        newTlds = [...selectedTlds, tld];
      } else {
        // Replace last TLD if at max
        newTlds = [...selectedTlds.slice(0, -1), tld];
      }
    }
    onChange == null || onChange(newTlds);
  };
  return /*#__PURE__*/React.createElement(Box, {
    dataHook: CoreDomainSearchDataHooks.tldSelector,
    gap: "SP2",
    verticalAlign: "middle",
    align: "left",
    flexWrap: "wrap",
    width: !stretch ? 'max-content' : undefined,
    flex: stretch ? '1' : undefined
  }, availableTlds.map(_ref2 => {
    let tld = _ref2.tld,
      isVoucherSupported = _ref2.isVoucherSupported;
    const isSelected = selectedTlds.includes(tld);
    const tag = /*#__PURE__*/React.createElement(Tag, {
      skin: "lightOutlined",
      key: tld,
      id: tld,
      removable: false,
      className: classnames(tldSelectorStyles.tldTagContainer, {
        [tldSelectorStyles.tldTagSelected]: isSelected,
        [tldSelectorStyles.stretch]: stretch
      }),
      onClick: () => handleTldToggle(tld),
      dataHook: `tld-option-${tld}`
    }, /*#__PURE__*/React.createElement(Box, {
      gap: "3px",
      direction: "horizontal",
      verticalAlign: "middle"
    }, /*#__PURE__*/React.createElement(Text, {
      size: "small"
    }, ".", tld), isVoucherSupported && /*#__PURE__*/React.createElement(GiftSmall, null)));
    return isMobile ? tag : /*#__PURE__*/React.createElement(Tooltip, {
      key: tld,
      content: /*#__PURE__*/React.createElement(TLDTooltipContent, {
        tld: tld,
        isVoucherSupported: isVoucherSupported
      }),
      placement: "bottom",
      maxWidth: "224px"
    }, tag);
  }));
};
export default TLDSelector;
//# sourceMappingURL=TLDSelector.js.map